exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".background{fill:#fafad2;z-index:-5}line{stroke:#fff;z-index:50}line.label-underline{stroke:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/code/UI/Math/MatrixViewer.scss
// module id = 70
// module chunks = 0